'use strict';

angular.module('substoreApp.controllers')
    .controller('reservationconfirmationController', ReservationConfirmationController);

function ReservationConfirmationController($scope, $routeParams, dialogData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_catalogue", "#/");

    $scope.progressBar.reset();

    function initDialogData() {
        var data = $scope.data = dialogData;
        var product = productDataCollector.collect(data.product);

        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + $routeParams.subscriptionTemplateId);
        $scope.breadcrumb.add("order");

        $scope.updateTeaser(
            product.texts.headerTitleReservation,
            product.texts.headerSubTitleReservation,
            product.images.headerImageReservationResourcePath);

        $scope.progressBar.setup({
            step: 2,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed
        });

        htmlTruster.trust(data.product);

        $scope.footnotes = product.productDescription.footnotes;

        // page_content_id: product.texts.productName + "-" + $routeParams.subscriptionTemplateId
        webtrekk.track('order_reservation', {
            shop_product_sku: $routeParams.subscriptionTemplateId
        });
    }

    $scope.$on('$routeChangeStart', function(scope, next, current) {
        if ((current.$$route.originalPath === "/reservationconfirmation/:subscriptionTemplateId")
            && next.$$route.originalPath === "/orderselection/:subscriptionTemplateId")
                $scope.go("/productdetails/"+$routeParams.subscriptionTemplateId);
    });

    initDialogData();
}